var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#173593"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 7.5C14.9609 7.5 15.3125 7.8498 15.3125 8.28125V10.625H24.6875V8.28125C24.6875 7.8498 25.0391 7.5 25.4688 7.5C25.8984 7.5 26.25 7.8498 26.25 8.28125V10.625H27.8125C29.5361 10.625 30.9375 12.0239 30.9375 13.75V29.375C30.9375 31.0986 29.5361 32.5 27.8125 32.5H12.1875C10.4614 32.5 9.0625 31.0986 9.0625 29.375V13.75C9.0625 12.0239 10.4614 10.625 12.1875 10.625H13.75V8.28125C13.75 7.8498 14.1016 7.5 14.5312 7.5ZM29.375 16.875H10.625V29.375C10.625 30.2393 11.3247 30.9375 12.1875 30.9375H27.8125C28.6768 30.9375 29.375 30.2393 29.375 29.375V16.875ZM27.8125 12.1875H12.1875C11.3247 12.1875 10.625 12.8857 10.625 13.75V15.3125H29.375V13.75C29.375 12.8857 28.6768 12.1875 27.8125 12.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCalendar);
export default __webpack_public_path__ + "static/media/activeCalendar.68506d33873d5833a7bd86b7b44b60d4.svg";
export { ForwardRef as ReactComponent };